
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },
  heading2: {
      marginBottom: "15px",
      
    },

  table: {
        backgroundColor:'white',
        padding: '1%',
        width:'100%',
        marginLeft:'0%',
        marginTop:'-15px'
        
  },

  items: {
    padding: '1%',
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '10%',
  },

  item_body: {
    padding: '6px ',
  },

  main_header: {
    marginBottom: '15px',
    backgroundColor: '#ddd',
    fontSize:'16px',
    fontWeight:'bold',
    padding:'10px',

  },
  left_header: {
    marginBottom: '1%',
    backgroundColor: '#707070',
    fontSize:'20px'
  },
  right_header: {
    marginBottom: '1%',
    backgroundColor: '#07B55E',
    fontSize:'20px'
  },
  sub_header:{
    padding:'10px',
    backgroundColor: '#ddd',
    width:'20%',
    fontWeight:'bold',
    color:'black',
  },
  active_header:{
    padding:'10px',
    backgroundColor: 'white',
    width:'20%',
    fontWeight:'bold',
    color:'black',
  },


  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '50%',
  },
  input_button:{
    backgroundColor: '#3CB3E2',
    color:'white',
    borderRadius: '4px',
    padding:'5px 30px 5px 30px',
    fontSize:'14px',
    fontWeight:'bold',
    marginLeft:'5px',
  },
  body_div:{
  },
  heading_div:{
    fontWeight:'bold',
    textAlign:'left',
  },
  button_view:{
    textAlign:'center',
    display:'flex',
    flexDirection:'row',
    padding:'15px',
  },



  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }

  
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetition/style.js